import type { ReactNode } from "react";
import { ApplicationListLoadingState } from "./ApplicationListLoadingState";
import type { ApplicationDetailPageStateProps } from "../types/pages";

function ApplicationDetailStateCard({
  children,
  testId,
}: {
  children: ReactNode;
  testId: string;
}) {
  return (
    <div
      className="flex min-w-0 flex-col overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm"
      data-testid={testId}
    >
      {children}
    </div>
  );
}

export function ApplicationDetailPageState({
  loading,
  error,
  hasApplicationData,
}: ApplicationDetailPageStateProps) {
  if (loading) {
    return (
      <ApplicationDetailStateCard testId="application-detail-loading-card">
        <ApplicationListLoadingState testId="application-detail-loading" />
      </ApplicationDetailStateCard>
    );
  }

  if (error) {
    return (
      <ApplicationDetailStateCard testId="application-detail-error-card">
        <div
          className="m-4 rounded-lg bg-red-50 p-4 text-center text-red-600 sm:p-8"
          data-testid="application-detail-error"
        >
          <h2 className="mb-2 text-base font-semibold" data-testid="application-detail-error-title">
            Error Loading Application
          </h2>
          <p className="text-sm" data-testid="application-detail-error-message">
            {error}
          </p>
        </div>
      </ApplicationDetailStateCard>
    );
  }

  if (!hasApplicationData) {
    return (
      <ApplicationDetailStateCard testId="application-detail-not-found-card">
        <div
          className="m-4 rounded-lg bg-slate-50 p-4 text-center text-slate-600 sm:p-8"
          data-testid="application-detail-not-found"
        >
          <h2
            className="mb-2 text-base font-semibold text-slate-800"
            data-testid="application-detail-not-found-title"
          >
            Application Not Found
          </h2>
          <p className="text-sm" data-testid="application-detail-not-found-message">
            The requested application could not be found.
          </p>
        </div>
      </ApplicationDetailStateCard>
    );
  }

  return null;
}
